import { curry } from "ramda"
import { isString } from "../../validate"
import { isInputText } from "./specialChecking"

export const isName = ({ value: str }) => {
  if (!isString(str)) return false

  const hasChineseChars = /[\u4E00-\u9FFF]/.test(str)
  if (hasChineseChars) return false

  const maxCompanyNameLength = 30
  if (str.length <= 0 || str.length > maxCompanyNameLength) return false

  return isInputText(str)
}

export default curry((field, { value }) => {
  const fieldValue = value[field]
  return isName({ value: fieldValue })
})
